export default __webpack_public_path__ + "static/2-f8e28ce1395bf317d3db533e8ed09bde.jpg";